import { commonGuards } from '@rci/self-serve-fido/guard/routing.guards';
import {
  getTemporarySuspensionAnalyticsConfig,
  temporarySuspensionRoutes,
} from '@rogers/self-serve-wireless/temporary-suspension';
import { provideAnalyticsConfiguration, provideSelfServeAnalyticsService } from '@rci/self-serve-fido/core/analytics';
import {
  DeviceDetailConfigService,
  DeviceDetailFacadeService,
  DeviceDetailStoreModule,
} from '@rogers/self-serve-wireless/device';
import { AccountDetailFacadeService } from '@rogers/self-serve-common/account';
import { MYACCOUNT_APPID } from '@rci/self-serve-fido/app.constant';
import { TemporarySuspensionConfigService } from '@rogers/self-serve-wireless/temporary-suspension-common';
import { TemporarySuspensionAppConfigService } from './temporary-suspension-app.config.service';
import { BreadcrumbsService } from '@rci/self-serve-fido/core/breadcrumbs/breadcrumbs.service';
import { UserInformationStateFacade } from '@rci/self-serve-fido/state/user-information/user-information-state.facade';
import { ContactDetailFacadeService } from '@rci/self-serve-fido/state/contact-detail/contact-detail-facade.service';
import { AccountDetailService } from '@rci/self-serve-fido/state/account/account-detail.service';
import { GLOBAL_APP_CONFIG } from '@rci/self-serve-shared';
import { StateService } from '@rci/state-service';
import { additionalServiceConfigFactory } from '@rci/self-serve-fido/shared/config/additional-service-config.factory';
import { importProvidersFrom } from '@angular/core';
import { AdditionalServiceStateModule } from '@rogers/self-serve-wireless/additional-service';
import { DeviceDetailConfig } from '@rci/self-serve-fido/wireless/config/device-detail-config';

export const temporarySuspensionAppRoutes = [
  {
    path: 'temporary-suspension',
    children: temporarySuspensionRoutes,
    canActivate: commonGuards,
    providers: [
      importProvidersFrom([AdditionalServiceStateModule, DeviceDetailStoreModule]),
      provideAnalyticsConfiguration(getTemporarySuspensionAnalyticsConfig(MYACCOUNT_APPID)),
      provideSelfServeAnalyticsService(),
      {
        provide: TemporarySuspensionConfigService,
        useClass: TemporarySuspensionAppConfigService,
        deps: [
          BreadcrumbsService,
          UserInformationStateFacade,
          ContactDetailFacadeService,
          DeviceDetailFacadeService,
          AccountDetailFacadeService,
          AccountDetailService,
          GLOBAL_APP_CONFIG,
          StateService,
        ],
      },
      {
        provide: DeviceDetailConfigService,
        useClass: DeviceDetailConfig,
      },
      additionalServiceConfigFactory(),
    ],
  },
];
